export default __webpack_public_path__ + "static/media/BiraCarvalho_02.81f97ced.jpg";